import React from 'react';
import { getRateByClass } from 'utils/fieldglass';

import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Job } from '@libs/graphql-types';

import { JobAccordion } from './JobAccordion';

const useStyles = makeStyles((theme: any) => ({
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(0.5),
  },
  value: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
}));

interface RatesAccordionProps {
  jobData: Job;
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
}

export const RatesAccordion: React.FC<RatesAccordionProps> = ({
  jobData,
  expanded,
  onChange,
}) => {
  const classes = useStyles();

  const OTRate = getRateByClass(jobData, 'OT');
  const DTRate = getRateByClass(jobData, 'DT');
  const STRate = getRateByClass(jobData, 'ST');

  const mappedData = {
    standardBillRate: STRate?.billAmountFormated || 'N/A',
    standardRateFactor: STRate?.factor || 'N/A',
    overtimeBillRate: OTRate?.billAmountFormated || 'N/A',
    overtimeRateFactor: OTRate?.factor || 'N/A',
    doubleBillRate: DTRate?.billAmountFormated || 'N/A',
    doubleRateFactor: DTRate?.factor || 'N/A',
  };

  const renderDetailItem = (label: string, value: string | number) => (
    <Grid item xs={12} sm={6}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.value}>{value}</Typography>
    </Grid>
  );

  return (
    <JobAccordion title="RATES" expanded={expanded} onChange={onChange}>
      <Grid container spacing={3}>
        {renderDetailItem('Standard Bill Rate:', mappedData.standardBillRate)}
        {renderDetailItem(
          'Standard Rate Factor:',
          mappedData.standardRateFactor,
        )}

        {renderDetailItem('Overtime Bill Rate:', mappedData.overtimeBillRate)}
        {renderDetailItem(
          'Overtime Rate Factor:',
          mappedData.overtimeRateFactor,
        )}

        {renderDetailItem('Double Bill Rate:', mappedData.doubleBillRate)}
        {renderDetailItem('Double Rate Factor:', mappedData.doubleRateFactor)}
      </Grid>
    </JobAccordion>
  );
};
